<template>
  <div
    class="oct-form__row"
    :class="{
      'oct-form__row--nowrap': nowrap,
      'oct-form__row--column': column 
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OctFormRow',
  props: {
    /** Fex's directionstyle */
    column: {
      type: Boolean,
      default: false
    },
    /** Fex's wrap style */
    nowrap: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-form__row {
  margin: 0 oct-rem(-12) oct-rem(-12);
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex: 1 1 100%;

  &--nowrap {
    flex-wrap: nowrap;
  }

  &--column {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
